import jsonFetch from '../util/jsonFetch.js';

export default () => jsonFetch('GetSystemStatus', [`${__API_BASE__}/open/system/status`]);
